<script>
import ButtonAll from '../UI/Button/ButtonAll.vue'
import SimulationNotification from './SimulationNotification.vue'

export default {
  components: {
    ButtonAll,
    SimulationNotification,
  },

  props: {
    isUpdating: { type: Boolean, default: false },
  },
}
</script>
<template>
  <SimulationNotification>
    <div v-html="$t('simulation.contractRefinancerNotification.message')"></div>
    <template #buttons>
      <ButtonAll
        type="validation"
        margin="no"
        icon="refresh"
        :label="$t('simulation.contractRefinancerNotification.button')"
        :loading="isUpdating"
        @click="$emit('update')"
      />
    </template>
  </SimulationNotification>
</template>
